export type TrainingAttemptEvidenceSource = 'standard' | 'remediation' | 'diagnosis';

export interface TrainingAttemptSourceParams {
  trainingSource: string | null;
  reviewFocus: string | null;
}

export interface ResolvedTrainingAttemptSource {
  source: TrainingAttemptEvidenceSource;
  reviewFocus: string | null;
}

export interface TrainingAttemptEvidenceCopyInput {
  moduleLabel: string;
  intensityLabel: string;
  source: TrainingAttemptEvidenceSource;
}

export interface TrainingAttemptEvidenceCopy {
  resultTitle: string;
  resultSummary: string;
  abilityEvidenceLabel: string;
}

export function resolveTrainingAttemptSource({
  trainingSource,
  reviewFocus,
}: TrainingAttemptSourceParams): ResolvedTrainingAttemptSource {
  const normalizedFocus = reviewFocus?.trim() || null;

  if (trainingSource === 'remediation') {
    return {
      source: 'remediation',
      reviewFocus: normalizedFocus,
    };
  }

  if (trainingSource === 'diagnosis') {
    return {
      source: 'diagnosis',
      reviewFocus: null,
    };
  }

  return {
    source: 'standard',
    reviewFocus: null,
  };
}

export function buildTrainingAttemptEvidenceCopy({
  moduleLabel,
  intensityLabel,
  source,
}: TrainingAttemptEvidenceCopyInput): TrainingAttemptEvidenceCopy {
  switch (source) {
    case 'remediation':
      return {
        resultTitle: '错题复盘短训结果',
        resultSummary: `${moduleLabel} ${intensityLabel} 已完成，来自错题复盘短训。`,
        abilityEvidenceLabel: '来自错题复盘短训的作答记录。',
      };
    case 'diagnosis':
      return {
        resultTitle: '入门诊断已完成',
        resultSummary: `${moduleLabel} ${intensityLabel} 已完成，已建立考试空间能力基线。`,
        abilityEvidenceLabel: '来自入门诊断题包的跨 Skill 抽样作答。',
      };
    case 'standard':
      return {
        resultTitle: '本轮训练结果',
        resultSummary: `${moduleLabel} ${intensityLabel} 已完成。`,
        abilityEvidenceLabel: '来自真实题库练习的作答记录。',
      };
    default: {
      const _exhaustive: never = source;
      return _exhaustive;
    }
  }
}
